let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aR7T2")).then(() => parcelRequire('5vhBu'));